import React, { useEffect, useState } from "react";
import {
  TextField,
  FormControl,
  InputLabel,
  CircularProgress,
  Button,
} from "@mui/material";
import { Autocomplete } from "@mui/material";
import { useSnackbar } from "notistack";
import {
  change_Advisor_api,
  get_advisor_list_api,
} from "../../DAL/adminAuth/auth";
import { makeStyles } from "@mui/styles";
import FilterChips from "../../components/customComponents/filterChips/FilterChips";

const useStyles = makeStyles(() => ({
  loading: {
    marginLeft: "50%",
    marginTop: "20%",
  },
}));

const INITIAL_VALUES = {
  title: "",
  last_name: "",
  description: "",
  categories: [],
  status: true,
  image: null,
  imagePreview: null,
  videoURL: "",
  post_code: "",
  email: "",
  password: "",
  contact_number: "",
};

export default function ChangeCaseAdvisor(props) {
  const { selectedObject, onCloseDrawer, caseSStatusDATA, get_user_list } =
    props;
  const [submitting, setSubmitting] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [selectedAdvisor, setSelectedAdvisor] = useState(null);
  const [caseData, setCaseData] = useState([]);
  const [selectedStates, setSelectedStates] = useState([]);
  const [availableStates, setAvailableStates] = useState([]);
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!selectedAdvisor) {
      enqueueSnackbar("Please select an attorney.", { variant: "warning" });
      return;
    }

    setSubmitting(true);
    const result = await change_Advisor_api(
      caseSStatusDATA._id,
      selectedAdvisor._id
    );
    if (result.code === 200) {
      enqueueSnackbar(result.message, { variant: "success" });
      onCloseDrawer();
      get_user_list();
      setSelectedAdvisor(null);
    } else {
      enqueueSnackbar(result.message, { variant: "error" });
    }
    setSubmitting(false);
  };

  const get_advisor_detail = async () => {
    setLoading(true);
    // Use selected states if available, otherwise use the case's state
    const statesToFilter =
      selectedStates.length > 0 ? selectedStates : [caseSStatusDATA?.state];

    const result = await get_advisor_list_api(
      statesToFilter,
      caseSStatusDATA?.case_type
    );
    if (result.code === 200) {
      setCaseData(result?.advisor);
      setLoading(false);
    } else {
      enqueueSnackbar(result.message, {
        variant: "error",
      });
      setLoading(false);
    }
  };

  // Get available states for the filter
  const getAvailableStates = () => {
    // This should be fetched from your API or config
    // For now, using a sample list
    return [
      "California",
      "Texas",
      "New York",
      "Florida",
      "Illinois",
      "Pennsylvania",
      "Ohio",
      "Georgia",
      "North Carolina",
      "Michigan",
    ];
  };

  useEffect(() => {
    setAvailableStates(getAvailableStates());
    // Initialize with the case's current state
    if (caseSStatusDATA?.state) {
      setSelectedStates([caseSStatusDATA.state]);
    }
  }, [caseSStatusDATA]);

  useEffect(() => {
    if (selectedStates.length > 0) {
      get_advisor_detail();
    }
  }, [selectedStates]);

  useEffect(() => {
    if (caseSStatusDATA?.advisor_id?._id && caseData.length > 0) {
      const currentAdvisor = caseData.find(
        (advisor) => advisor._id === caseSStatusDATA.advisor_id._id
      );
      if (currentAdvisor) {
        setSelectedAdvisor(currentAdvisor);
      }
    }
  }, [caseSStatusDATA, caseData]);

  if (isLoading) {
    return <CircularProgress className={classes.loading} color="primary" />;
  }

  return (
    <form onSubmit={handleSubmit} className="">
      <FilterChips
        options={availableStates}
        selectedValues={selectedStates}
        onChange={setSelectedStates}
        label="Select States"
        placeholder="Choose states..."
      />

      <FormControl fullWidth margin="normal">
        <Autocomplete
          id="advisor-autocomplete"
          options={caseData}
          getOptionLabel={(option) => option.name || ""}
          value={selectedAdvisor}
          onChange={(event, newValue) => {
            setSelectedAdvisor(newValue);
          }}
          renderInput={(params) => (
            <TextField {...params} label="Choose Attorney" variant="outlined" />
          )}
        />
      </FormControl>

      <div className="text-end mt-2">
        <Button
          variant="contained"
          disabled={submitting || !selectedAdvisor}
          onClick={handleSubmit}
        >
          {submitting ? "Submitting..." : "Submit"}
        </Button>
      </div>
    </form>
  );
}
